"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const react_1 = __importDefault(require("react"));
const styledComponents_1 = require("../styledComponents");
const format_1 = require("@/utils/format");
const material_1 = require("@mui/material");
const LinkButton_1 = __importDefault(require("../interactions/LinkButton"));
const CustomToolTip_1 = __importStar(require("../interactions/CustomToolTip"));
const Amount_1 = __importDefault(require("../layout/Amount"));
const styledComponents_2 = require("../styledComponents");
const styled_components_1 = __importDefault(require("styled-components"));
const Card = ({ wallet, hover, LinkCard, noSign, noPadding, order, data, key, children, cardwidth, isborder, bg, amountSize, radius, margin, horizontal, i, arrowed, }) => {
    return (react_1.default.createElement(styledComponents_2.DataCardItem, { hover: hover, i: i, arrowed: arrowed, horizontal: horizontal, order: order, key: key, cardwidth: cardwidth, isborder: isborder, bg: bg, radius: radius, margin: margin },
        react_1.default.createElement(styledComponents_2.DataCardInner, { horizontal: horizontal, style: {
                display: 'flex',
                padding: noPadding ? 0 : '',
                flexDirection: 'column',
                height: data.name === 'Circulating Supply' ? '' : '100%',
                gap: 18,
            } },
            data && (react_1.default.createElement(CustomBox, { horizontal: horizontal },
                react_1.default.createElement(material_1.Box, { sx: {
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: 'fit-content',
                    } },
                    data.title && (react_1.default.createElement(styledComponents_1.CardTitle, { style: {
                            fontSize: horizontal ? '0.8125em ' : '',
                            lineHeight: 1,
                            width: '100%',
                        } }, (0, format_1.formatLabel)(data.title))),
                    data.name && (react_1.default.createElement(styledComponents_1.CardTitle, { style: { fontSize: horizontal ? '0.8125em ' : '', width: '100%' } }, data.name)),
                    react_1.default.createElement(material_1.Box, { style: { paddingLeft: '10px', display: 'flex', gap: 10 } },
                        data.url && react_1.default.createElement(LinkButton_1.default, { url: data.url }),
                        data.description && react_1.default.createElement(CustomToolTip_1.default, { description: data.description }),
                        wallet && react_1.default.createElement(CustomToolTip_1.WalletTooltip, { payload: wallet.payload }))),
                react_1.default.createElement(material_1.Box, { style: {
                        display: 'flex',
                        alignItems: 'center',
                    } }, data.value > 0 ? (react_1.default.createElement(Amount_1.default, { noSign: data.title === 'reward Rate' || noSign ? true : false, token: data.token, horizontal: horizontal, size: amountSize, amount: data.title === 'reward Rate' ? null : (0, format_1.formatAmount)(data.value) })) : (react_1.default.createElement(Amount_1.default, { noSign: data.title === 'reward Rate' || noSign ? true : false, token: data.token, horizontal: horizontal, size: amountSize, amount: data.title === 'reward Rate' ? null : (0, format_1.formatAmount)(data.value) }))))),
            data.location && react_1.default.createElement(styledComponents_1.Tag, null, data.location),
            children && react_1.default.createElement(styledComponents_2.GridContainer, null, children)),
        react_1.default.createElement(material_1.Box, { style: {
                width: '85%',
                margin: '0 auto',
            } })));
};
exports.Card = Card;
const CustomBox = (0, styled_components_1.default)(material_1.Box) `
  display: flex;
  flex-flow: ${(props) => {
    return props.horizontal ? 'row' : 'column';
}};
  justify-content: space-between;
  width: 100%;
  gap: 8px;

  @media (max-width: 480px) {
    display: block;
    padding: 5px 10px;
  }
`;
